import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import decode from 'jwt-decode';
import messageHandler from 'utils/messageHandler';
import io from 'socket.io-client';
import { checkToken } from 'utils/checkToken';
import {
  emptyAllRealEstateData,
  setRealEstateListNull
} from './realEstateSlice';
import { setPropsArrayToInitial } from './propsSlice';
import { setBranchToInitial } from './branchOfficeSlice';

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    currentUser: null,
    loading: true,
    socket: null
  },
  reducers: {
    setCurrentUser: (state, { payload }) => {
      state.currentUser = payload;
      state.loading = false;
      if (!payload) return;
      if (!state.socket) {
        state.socket = io(process.env.REACT_APP_SOCKET, {
          query: `userId=${payload.id}&type=user`,
          transports: ['websocket'],
          path: '/socket.io'
        });
      }
      if (!payload) {
        state.socket.disconnect();
        state.socket = null;
      }
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    }
  }
});

export const { setCurrentUser, setLoading } = loginSlice.actions;
export const loginColab = (userData, navigate) => async dispatch => {
  dispatch(setLoading(true));

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/login`,
      userData
    );

    const newToken = data.token;
    if (newToken) {
      localStorage.setItem('token_A', newToken);
      const decoded = decode(newToken);
      dispatch(setCurrentUser(decoded));
    }

    localStorage.setItem('token_A', data.token);

    return navigate('/perfil');
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    dispatch(setLoading(false));
  }
};

export const updateUser = userData => async dispatch => {
  try {
    localStorage.setItem('token_A', userData);
    const userLogged = await decode(userData, process.env.JWT_SECRET);
    dispatch(setCurrentUser(userLogged));
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const logOut = navigate => async dispatch => {
  try {
    localStorage.removeItem('token_A');
    dispatch(setCurrentUser(null));

    // Clear Redux data
    dispatch(emptyAllRealEstateData());
    dispatch(setRealEstateListNull());
    dispatch(setPropsArrayToInitial());
    dispatch(setBranchToInitial());

    return navigate('/', { replace: true });
  } catch (e) {
    messageHandler('error', e.response?.data.message);
  }
};

export const checkSession = navigate => async dispatch => {
  const [isValid, tokenDecoded] = checkToken();
  if (isValid) {
    dispatch(setCurrentUser(tokenDecoded));
  } else {
    dispatch(setCurrentUser(null));
    dispatch(logOut(navigate));
  }
};

export const tokenRefresh = token => async dispatch => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/refresh-token`,
      { token: token }
    );

    const newToken = data.newToken;
    if (newToken) {
      localStorage.setItem('token_A', newToken);
      const decoded = decode(newToken);
      dispatch(setCurrentUser(decoded));
    }
  } catch (e) {
    console.log(e);
  }
};

export const regenerateToken = () => async dispatch => {
  try {
    const token = localStorage.getItem('token_A');
    if (token) {
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER}/users/regenerate-token`
      );

      const newToken = data.token;
      if (newToken) {
        localStorage.setItem('token_A', newToken);
        const decoded = decode(newToken);
        dispatch(setCurrentUser(decoded));
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export default loginSlice.reducer;
